import { Box } from '../CommonComponents/OPL/Box/Box';
import styled from '../theme/theme';

export const Wrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  width: '100%',
  background: theme.background,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
}));
